var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefix + "-move-trigger")},[_c('div',{class:(_vm.prefix + "-move-trigger-point")},[_c('i'),_c('i'),_c('i'),_c('i'),_c('i')])])}
var staticRenderFns = []

export { render, staticRenderFns }